import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AppProviders } from './providers/AppProviders';
import { StripeProvider } from './providers/StripeProvider';
import { useAuthStore } from './stores/auth.store';
import App from './App';
import './styles/globals.css';

// Initialize auth token from persisted state
useAuthStore.getState().initializeAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <AppProviders>
        <StripeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </StripeProvider>
      </AppProviders>
    </HelmetProvider>
  </React.StrictMode>
);
